import type { Plan } from "@circle-react/types";
import { PlanCard } from "./PlanCard";

interface ImageVariants {
  large: string;
  medium: string;
  small: string;
  thumbnail: string;
}

interface RightSideProps {
  alt: string;
  image1x: string;
  imageVariants: ImageVariants;
  isLoading: boolean;
  plan: Plan;
}

export const RightSide = ({
  image1x,
  imageVariants,
  alt,
  plan,
  isLoading,
}: RightSideProps) => {
  const srcSet = `${imageVariants.thumbnail} 300w, ${imageVariants.small} 600w, ${imageVariants.medium} 900w, ${imageVariants.large} 1200w`;

  return (
    <div className="hidden h-full flex-1 lg:flex">
      <div className="relative size-full">
        <div className="size-full">
          <img
            src={image1x}
            srcSet={srcSet}
            alt={alt}
            loading="eager"
            className="size-full object-cover"
          />
        </div>
        <PlanCard plan={plan} isLoading={isLoading} />
      </div>
    </div>
  );
};
